<!--
// app/components/pages/players-player/DraftPlayerScores.vue
-->
<script setup lang="ts">
//import type { PlayerRanking } from "#shared/player/domain/Player";

type Props = {
  draftScores: [{ name: string; total: string }];
};
const props = defineProps<Props>();
</script>

<template>
  <div class="flex gap-2 flex-wrap lg:flex-nowrap pt-6 pb-2 lg:pt-0 lg:pb-0">
    <div
      v-for="(stat, index) in draftScores"
      :key="index"
      class="rounded-lg px-3 py-3 lg:py-8 bg-gray-800 flex lg:flex-col lg:gap-2 lg:w-auto w-full lg:flex-1 lg:relative items-center"
    >
      <p class="text-gray-400 text-sm lg:text-center">
        {{ stat.name }}
      </p>
      <p class="lg:text-lg lg:mt-auto text-xs font-bold ms-auto lg:ms-0">{{ stat.total }}</p>
    </div>
  </div>
</template>

<style scoped></style>
